// extracted by mini-css-extract-plugin
export default {"total-campaigns":"All_total-campaigns__fd6hi","button":"All_button__u03Wj","switch":"All_switch__IBJ++","slider":"All_slider__bU+fj","round":"All_round__adUJ0"};